'use client';

import {FileDownloadWarningModal, hasAckedFileDownload} from 'iq-takehomes/components/file_download_warning_modal';
import {FileText} from 'lucide-react';
import {useState} from 'react';

type Props = {
  s3Key: string;
  url: string;
};

// Download link for a user-submitted file. Shows a one-time risk warning before the first
// download; once acknowledged ("don't show again") it downloads directly.
export function UserFileDownloadLink({s3Key, url}: Props) {
  const filename = s3Key.split('/').pop() ?? s3Key;
  const [warnOpen, setWarnOpen] = useState(false);

  function handleClick(e: React.MouseEvent) {
    if (hasAckedFileDownload()) return;
    e.preventDefault();
    setWarnOpen(true);
  }

  return (
    <>
      <a
        href={url}
        target='_blank'
        rel='noopener noreferrer'
        onClick={handleClick}
        className='flex items-center gap-1.5 text-sm text-iq-orange hover:underline'>
        <FileText className='w-4 h-4 shrink-0' strokeWidth={1.75} />
        <span className='truncate'>{filename}</span>
      </a>
      {warnOpen && <FileDownloadWarningModal url={url} onClose={() => setWarnOpen(false)} />}
    </>
  );
}
